import React from "react";
import { LogoContainer, Logo } from "./contentOnlyLogo.styles";
import { useAppState } from "main/context/app-context";

export const ContentOnlyLogo: React.FC = () => {
  const { applicationData } = useAppState();

  return (
    <LogoContainer>
      <Logo
        src={"data:image/png;base64, " + applicationData?.entity?.brandLogo}
        alt={applicationData?.entity?.name}
      />
    </LogoContainer>
  );
};
